const escapeRegExpMatch = function (text: string) {
  return text.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
};

export const isExactMatch = (text: string, match: string) => {
  return new RegExp(`\\b${escapeRegExpMatch(match)}\\b`).test(text);
};
